// @mui material components
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function PostErrorFallback() {
  return (
    <MKBox
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      sx={{
        minHeight: { xs: 480, sm: 520 },
        border: ({ borders: { borderWidth }, palette: { grey } }) =>
          `${borderWidth[1]} dashed ${grey[400]}`,
        borderRadius: "xl",
      }}
    >
      <Icon color="error" fontSize="large">
        warning
      </Icon>
      <MKTypography variant="button" color="text" mt={1} sx={{ textAlign: "center", p: 2 }}>
        No se pudo cargar esta publicación.
      </MKTypography>
    </MKBox>
  );
}

export default PostErrorFallback;
